export default "__VITE_PUBLIC_ASSET__4be808e0__"